/**
 * Generated file, do not edit directly!
 */

/** Easings define the rate of change of an animation over time, affecting speed, acceleration, and deceleration. */

const Decelerate = [0, 0, 0.2, 1];
const Accelerate = [0.5, 0, 1, 1];
const SlowInFastOut = [0.8, 0, 0.5, 1];
const FastInSlowOut = [0.4, 0, 0.2, 1];
const OutBack = [0.4, 1.6, 0.7, 1];
const RotateElastic = [0.8, 0.3, 0.3, 0.8];
export default {
  /**
   * Use to convey the deceleration of an object, such as when it's coming to a stop. It starts at a fast pace and then slows down at the end.
   * Value: [ 0, 0,0.2,1 ].
   */
  Decelerate,
  /**
   * Use to convey the acceleration of an object, such as when it's being launched. It starts at a slow pace and then speeds up at the end.
   * Value: [ 0.5, 0,1,1 ].
   */
  Accelerate,
  /**
   * Use to draw attention to an object. It starts slowly, accelerates in the middle, and then slows down again at the end.
   * Value: [ 0.8, 0,0.5,1 ].
   */
  SlowInFastOut,
  /**
   * Use to move or scale objects. It starts slowly, quickly accelerates in the middle, and slows down at the end.
   * Value: [ 0.4, 0,0.2,1 ].
   */
  FastInSlowOut,
  /**
   * Use to convey a playful or elastic effect, such as when an object bounces or stretches. It overshoots its target position before settling back into place.
   * Value: [ 0.4, 1.6,0.7,1 ].
   */
  OutBack,
  /**
   * Use to create dynamic, nonlinear rotation that adds energy and movement, ideal for rotating loading indicators.
   * Value: [ 0.8, 0.3,0.3,0.8 ].
   */
  RotateElastic,
};
